import _regeneratorValues from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regeneratorValues.js";
import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { toBatchGetExpress } from '@/api/correspondence/task/form';
import { json2excel } from '@/util/json2excel';
import CheckData from './check-data.vue';
import { mapState } from 'vuex';
import { transformInputCodes } from '@/util';
export default {
  name: 'export-component',
  data: function data() {
    return {
      codes: '',
      loading: false,
      checked: true,
      template: null,
      list: [],
      expressPayType: [{
        label: '寄付现结',
        value: '1'
      }, {
        label: '寄付月结',
        value: '2'
      }, {
        label: '到付',
        value: '3'
      }, {
        label: '第三方付',
        value: '4'
      }],
      expressSendType: [{
        label: '顺丰特快',
        value: '1'
      }, {
        label: '顺丰标快',
        value: '2'
      }],
      model: {
        form: '',
        sender: '函证中心',
        phone: '',
        address: '',
        payType: '寄付现结',
        type: '顺丰标快',
        tel: '',
        Num: '',
        _COde: '',
        _Num: ''
      },
      rows: {},
      activeNames: '1',
      columns: ['用户订单号', '寄件公司', '寄件人', '寄件电话', '寄件详细地址', '收件公司', '收件人', '收件电话', '收件手机', '收件详细地址', '托寄物内容', '托寄物数量', '包裹重量', '寄方备注', '运费付款方式', '业务类型', '件数'],
      name: '顺丰发函导入模板',
      colors: ['success', 'error', 'primary'],
      index: 0,
      items: {}
    };
  },
  computed: _objectSpread(_objectSpread({
    dataCodes: function dataCodes() {
      var codes = this.codes;
      return transformInputCodes(codes);
    },
    currentTableData: function currentTableData() {
      return this.list.filter(function (item) {
        return item.c02Status === '已审核';
      });
    }
  }, mapState('cpscc', ['userInfo', 'localStorageName'])), {}, {
    isHX: function isHX() {
      return this.$store.state.cpscc.isHX;
    },
    isAdmin: function isAdmin() {
      var user = this.userInfo;
      if (user && user.data2) {
        return user.data2.admin;
      }
      return false;
    },
    isCpscAdmin: function isCpscAdmin() {
      if (this.userInfo && this.userInfo.data2) {
        if (Array.isArray(this.userInfo.data2.roles)) {
          return this.userInfo.data2.roles.includes('函证中心管理员');
        }
      }
      return false;
    },
    isSender: function isSender() {
      if (this.userInfo && this.userInfo.data2) {
        if (Array.isArray(this.userInfo.data2.roles)) {
          return this.userInfo.data2.roles.includes('发函操作员');
        }
      }
      return false;
    }
  }),
  methods: {
    codeChange: function codeChange(val) {
      // console.log(val.split('H'))
    },
    objectSpanMethod: function objectSpanMethod(_ref) {
      var row = _ref.row,
        column = _ref.column,
        rowIndex = _ref.rowIndex,
        columnIndex = _ref.columnIndex;
      if (columnIndex === 5) {
        if (this.rows[row.c02ConfirmCode]) {
          return this.rows[row.c02ConfirmCode];
        } else {
          var res = this.list.filter(function (item) {
            return row.c02ObjAddress === item.c02ObjAddress;
          });
          if (res.length > 1) {
            var rows = res.filter(function (item) {
              return row.c02ConfirmCode !== item.c02ConfirmCode;
            });
            for (var i = 0; i < rows.length; i++) {
              this.rows[rows[i].c02ConfirmCode] = {
                rowspan: 0,
                colspan: 0
              };
            }
            this.rows[row.c02ConfirmCode] = {
              rowspan: res.length,
              colspan: 1
            };
            return this.rows[row.c02ConfirmCode];
          }
        }
      }
    },
    submit: function submit() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.loading = true;
              _this.rows = [];
              _context.n = 1;
              return _this.$awaitTo(toBatchGetExpress(_this.dataCodes));
            case 1:
              _yield$_this$$awaitTo = _context.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 2);
              err = _yield$_this$$awaitTo2[0];
              data = _yield$_this$$awaitTo2[1];
              _this.loading = false;
              if (!err) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              if (Array.isArray(data)) {
                _this.sortList(data);
              } else {
                _this.list = [];
              }
              // this.sortList(data)
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    sortList: function sortList(data) {
      var d = Array.isArray(data) ? JSON.parse(JSON.stringify(data)) : JSON.parse(JSON.stringify(this.list));
      var obj = {};
      var index = 0;
      for (var i = 0; i < d.length; i++) {
        if (obj[d[i].c02ObjAddress]) {
          obj[d[i].c02ObjAddress].data.push(d[i]);
        } else {
          ++index;
          obj[d[i].c02ObjAddress] = {
            data: [d[i]],
            index: index
          };
        }
      }
      var newList = Object.values(obj).sort(function (a, b) {
        return a.index - b.index;
      }).map(function (item) {
        return item.data;
      });
      this.list = newList.flat(Infinity);
      // this.list = d.sort((a, b) => {
      //   return a.c02ObjAddress.localeCompare(b.c02ObjAddress, 'zh-CN')
      // })
      this.updateList();
    },
    updateModelValues: function updateModelValues(value) {
      localStorage.setItem(this.localStorageName, JSON.stringify(value));
    },
    getModelValues: function getModelValues() {
      var res = localStorage.getItem(this.localStorageName);
      if (res) {
        var obj = JSON.parse(res);
        for (var key in obj) {
          if (obj.hasOwnProperty(key)) {
            this.model[key] = obj[key];
          }
        }
      } else {
        if (this.isHX) {
          this.model.form = '华兴会计师事务所（特殊普通合伙）广东分所';
          this.model.phone = '18998441062';
          this.model.tel = '';
          this.model.address = '广州市天河区天河路230号万菱国际大厦A塔28楼';
          this.model.sender = '函证中心';
          this.model.payType = '寄付现结';
          this.model.type = '顺丰标快';
        }
      }
    },
    updateAddressList: function updateAddressList() {},
    updateList: function updateList() {
      var _this2 = this;
      if (!this.model.form || !this.model.phone || !this.model.address) {
        this.$message.error('请先完善默认带入数据');
        return;
      }
      this.list = this.list.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          form: _this2.model.form,
          sender: _this2.model.sender,
          phone: _this2.model.phone,
          _tel: _this2.model.tel,
          address: _this2.model.address,
          payType: _this2.model.payType,
          type: _this2.model.type,
          expressNum: 1,
          _Num: _this2.model._Num,
          _COde: _this2.model._COde,
          _codes: [item.c02ConfirmCode]
        });
      });
      if (this.currentTableData.length) {
        this.name = "".concat(this.currentTableData[0].c02ConfirmCode, "_\u987A\u4E30\u53D1\u51FD\u5BFC\u5165\u6A21\u677F");
      }
      this.updateModelValues(this.model);
    },
    prompt: function prompt() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              return _context2.a(2, new Promise(function (resolve, reject) {
                _this3.$prompt('文件名', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消'
                }).then(function (_ref2) {
                  var value = _ref2.value;
                  resolve(value);
                }).catch(function () {
                  reject(new Error('没有值'));
                });
              }));
          }
        }, _callee2);
      }))();
    },
    transformExcel: function transformExcel() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var list, newList, _loop, i, arr, _loop2, _i;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              list = [];
              newList = _this4.currentTableData.map(function (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  _codes: [item.c02ConfirmCode]
                });
              });
              if (!(newList.length === 0)) {
                _context5.n = 1;
                break;
              }
              _this4.$message.warning('未找到符合条件的函证(已审核)');
              return _context5.a(2, Promise.reject(new Error('未找到符合条件的函证(已审核)')));
            case 1:
              if (!_this4.checked) {
                _context5.n = 5;
                break;
              }
              _loop = /*#__PURE__*/_regenerator().m(function _loop(i) {
                var index;
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      index = list.findIndex(function (item) {
                        return item.c02ObjAddress === newList[i].c02ObjAddress;
                      });
                      if (index !== -1) {
                        if (Array.isArray(list[index]._codes)) {
                          list[index]._codes.push(newList[i].c02ConfirmCode);
                        } else {
                          list[index]._codes = [newList[i].c02ConfirmCode];
                        }
                        list[index]._codes = Array.from(new Set(list[index]._codes));
                      } else {
                        list.push(newList[i]);
                      }
                    case 1:
                      return _context3.a(2);
                  }
                }, _loop);
              });
              i = 0;
            case 2:
              if (!(i < newList.length)) {
                _context5.n = 4;
                break;
              }
              return _context5.d(_regeneratorValues(_loop(i)), 3);
            case 3:
              i++;
              _context5.n = 2;
              break;
            case 4:
              _context5.n = 6;
              break;
            case 5:
              list = newList;
            case 6:
              arr = []; // 每10个函证编码切割一次, 避免字数过多打印的时候显示不全
              _loop2 = /*#__PURE__*/_regenerator().m(function _loop2(_i) {
                var res;
                return _regenerator().w(function (_context4) {
                  while (1) switch (_context4.n) {
                    case 0:
                      if (Array.isArray(list[_i]._codes) && list[_i]._codes.length > 10) {
                        res = _this4.chunkArray(list[_i]._codes, 10);
                        if (Array.isArray(res) && res.length) {
                          res.forEach(function (item) {
                            arr.push(_objectSpread(_objectSpread({}, list[_i]), {}, {
                              _codes: item
                            }));
                          });
                        }
                      } else {
                        arr.push(list[_i]);
                      }
                    case 1:
                      return _context4.a(2);
                  }
                }, _loop2);
              });
              _i = 0;
            case 7:
              if (!(_i < list.length)) {
                _context5.n = 9;
                break;
              }
              return _context5.d(_regeneratorValues(_loop2(_i)), 8);
            case 8:
              _i++;
              _context5.n = 7;
              break;
            case 9:
              return _context5.a(2, Promise.resolve(arr));
          }
        }, _callee3);
      }))();
    },
    chunkArray: function chunkArray(arr, len) {
      var chunks = Array.from({
        length: Math.ceil(arr.length / len)
      }, function (_, i) {
        return arr.slice(i * len, i * len + len);
      });
      return chunks;
    },
    exportExcel: function exportExcel() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var columns, _yield$_this5$$awaitT, _yield$_this5$$awaitT2, err, arr, _yield$_this5$$awaitT3, _yield$_this5$$awaitT4, err2, data2;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              columns = _this5.columns;
              _context6.n = 1;
              return _this5.$awaitTo(_this5.transformExcel());
            case 1:
              _yield$_this5$$awaitT = _context6.v;
              _yield$_this5$$awaitT2 = _slicedToArray(_yield$_this5$$awaitT, 2);
              err = _yield$_this5$$awaitT2[0];
              arr = _yield$_this5$$awaitT2[1];
              if (!err) {
                _context6.n = 2;
                break;
              }
              return _context6.a(2);
            case 2:
              _context6.n = 3;
              return _this5.$awaitTo(_this5.$dialog(CheckData, {
                dialog: {
                  title: '顺丰发函导入模板(预览)',
                  width: '980px'
                },
                props: {
                  data: arr,
                  type: 1,
                  expressSendType: _this5.expressSendType,
                  expressPayType: _this5.expressPayType,
                  isHX: _this5.isHX,
                  isAdmin: _this5.isAdmin,
                  isCpscAdmin: _this5.isCpscAdmin,
                  isSender: _this5.isSender,
                  columns: columns,
                  excelName: _this5.name
                }
              }, function (template) {
                _this5.template = template;
              }));
            case 3:
              _yield$_this5$$awaitT3 = _context6.v;
              _yield$_this5$$awaitT4 = _slicedToArray(_yield$_this5$$awaitT3, 2);
              err2 = _yield$_this5$$awaitT4[0];
              data2 = _yield$_this5$$awaitT4[1];
              _this5.template = null;
            case 4:
              return _context6.a(2);
          }
        }, _callee4);
      }))();
    },
    exportExcel2: function exportExcel2() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var columns, _yield$_this6$$awaitT, _yield$_this6$$awaitT2, err, arr, _yield$_this6$$awaitT3, _yield$_this6$$awaitT4, err2, data2;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              columns = [['', '收方信息', '', '', '', '', '', '', '', '寄方信息', '', '', '', '', '', '', '', '货物信息', '', '', '', '', '', '', '物流产品信息', '', '', '揽收&派送', '', '', '', '', '', '', '代收货款', '', '保价服务', '', '纸质回单', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '拍照回传', '', '', '电子回单', '', '包装服务', '', '超长超重', '保鲜服务', '密钥认证', '备注&补充信息', ',', '', ''], ['客户订单号', '*收件人', '*收件人手机', '收件人电话', '收件公司', '收件人地址-省', '收件人地址-市', '收件人地址-区', '*收件人详细地址', '*寄件人', '*寄件人手机', '寄件人电话', '寄件公司', '寄件人地址-省', '寄件人地址-市', '寄件人地址-区', '*寄件人详细地址', '*托寄物', '托寄物数量', '包裹总数量', '包裹总重量（KG）', '长（cm）', '宽（cm）', '高（cm）', '*物流产品', '*物流付款方式', '月结卡号', '是否通知揽件', '预约揽收日期', '预约揽收时间', '定时派送类型', '派送指定日期', '派送指定时段', '自取', '代收金额', '代收卡号', '保价金额', '定额保-保价档位', '纸质回单-签名', '纸质回单-盖章', '纸质回单-登记身份证', '纸质回单-身份证复印件', '回单份数', '回单备注', '是否签返第三方', '第三方收件人', '第三方公司', '第三方手机', '第三方电话', '第三方省', '第三方市', '第三方区', '第三方详细地址', '拍照回传', '拍照张数', '拍照备注', '文件ID', '待签署文件名', '包材编码', '包装服务费', '超长超重服务费', '保鲜服务', '密钥认证', '订单备注', '备注字段1', '备注字段2', '备注字段3']];
              _context7.n = 1;
              return _this6.$awaitTo(_this6.transformExcel());
            case 1:
              _yield$_this6$$awaitT = _context7.v;
              _yield$_this6$$awaitT2 = _slicedToArray(_yield$_this6$$awaitT, 2);
              err = _yield$_this6$$awaitT2[0];
              arr = _yield$_this6$$awaitT2[1];
              if (!err) {
                _context7.n = 2;
                break;
              }
              return _context7.a(2);
            case 2:
              _context7.n = 3;
              return _this6.$awaitTo(_this6.$dialog(CheckData, {
                dialog: {
                  title: '顺丰发函导入模板(预览)',
                  width: '980px'
                },
                props: {
                  data: arr,
                  type: 2,
                  expressSendType: _this6.expressSendType,
                  expressPayType: _this6.expressPayType,
                  columns: columns
                }
              }, function (template) {
                _this6.template = template;
              }));
            case 3:
              _yield$_this6$$awaitT3 = _context7.v;
              _yield$_this6$$awaitT4 = _slicedToArray(_yield$_this6$$awaitT3, 2);
              err2 = _yield$_this6$$awaitT4[0];
              data2 = _yield$_this6$$awaitT4[1];
              _this6.template = null;
              // if (!data2) {
              //   this.template = null
              // }
              // if (err2) {
              //   return
              // }

              // this.loading = true
              // const merge = [
              //   { s: { r: 0, c: 1 }, e: { r: 0, c: 8 } },
              //   { s: { r: 0, c: 9 }, e: { r: 0, c: 16 } },
              //   { s: { r: 0, c: 17 }, e: { r: 0, c: 23 } },
              //   { s: { r: 0, c: 24 }, e: { r: 0, c: 26 } },
              //   { s: { r: 0, c: 27 }, e: { r: 0, c: 33 } },
              //   { s: { r: 0, c: 34 }, e: { r: 0, c: 35 } },
              //   { s: { r: 0, c: 36 }, e: { r: 0, c: 37 } },
              //   { s: { r: 0, c: 38 }, e: { r: 0, c: 52 } },
              //   { s: { r: 0, c: 53 }, e: { r: 0, c: 55 } },
              //   { s: { r: 0, c: 56 }, e: { r: 0, c: 57 } },
              //   { s: { r: 0, c: 58 }, e: { r: 0, c: 59 } },
              //   { s: { r: 0, c: 63 }, e: { r: 0, c: 66 } }
              // ]
              // const data = data2.map((item) => {
              //   return [
              //     item.$id,
              //
              //     // 收方信息
              //     item.c02ObjStaff,
              //     item.c02ObjMobile,
              //     item.$phone,
              //     item.c03CusName,
              //     item.$p,
              //     item.$c,
              //     item.$t,
              //     item.c02ObjAddress,
              //
              //     // 寄方信息
              //     item.sender,
              //     item.phone,
              //     item._tel,
              //     item.form,
              //     item.$p2,
              //     item.$c2,
              //     item.$t2,
              //     item.address,
              //
              //     // 货物信息
              //     item.$tuojiwu,
              //     item.$tuojiwushuliang,
              //     item.$baonangshu,
              //     item.$zhongliang,
              //     '',
              //     '',
              //     '',
              //
              //     // 物流产品信息
              //     item.$express,
              //     // item.type,
              //     item.payType,
              //     item._Num,
              //
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //     '',
              //
              //     item._codes.join(','),
              //     item.$ext1,
              //     item.$ext2,
              //     item.$ext3
              //   ]
              // })
              // await json2excel([...columns, ...data], `${this.name ? this.name : `${arr[0].c02ConfirmCode}_顺丰发函导入模板`}.xlsx`, merge)
              // this.loading = false
            case 4:
              return _context7.a(2);
          }
        }, _callee5);
      }))();
    },
    tableRowClassName: function tableRowClassName(_ref3) {
      var row = _ref3.row,
        rowIndex = _ref3.rowIndex;
      if (row.c02Status !== '已审核') {
        return 'warning-row';
      }
      return '';
    },
    getStatus: function getStatus(status) {
      if (status === '已审核') {
        return 'success';
      }
      return 'danger';
    },
    updateColor: function updateColor(row) {
      if (!this.items[row.c02ObjAddress]) {
        this.items[row.c02ObjAddress] = this.colors[this.index];
        this.index++;
        if (this.index > 2) {
          this.index = 0;
        }
      }
      return this.items[row.c02ObjAddress];
    },
    cellClassName: function cellClassName(_ref4) {
      var row = _ref4.row,
        columnIndex = _ref4.columnIndex,
        rowIndex = _ref4.rowIndex;
      if (columnIndex === 5) {
        if (this.list[rowIndex + 1] && this.list[rowIndex + 1].c02ObjAddress === row.c02ObjAddress) {
          return "".concat(this.updateColor(row), "-row");
        }
        if (this.list[rowIndex - 1] && this.list[rowIndex - 1].c02ObjAddress === row.c02ObjAddress) {
          return "".concat(this.updateColor(row), "-row");
        }
      }
      return '';
    }
  },
  created: function created() {
    // this.updateList()
    // this.sortList()
    this.getModelValues();
  }
};